var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Solid",
    fill: "currentColor",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 184,
    cy: 96,
    r: 64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208,352A128,128,0,1,0,336,224,128.145,128.145,0,0,0,208,352Zm118.4,8c-25.585,0-46.4-17.944-46.4-40s20.815-40,46.4-40H328V264.615a8,8,0,0,1,16,0V280h1.6c25.585,0,46.4,17.944,46.4,40a8,8,0,0,1-16,0c0-13.233-13.638-24-30.4-24H344v48h1.6c25.585,0,46.4,17.944,46.4,40s-20.815,40-46.4,40H344v16a8,8,0,0,1-16,0V424h-1.6c-25.585,0-46.4-17.944-46.4-40a8,8,0,0,1,16,0c0,13.233,13.638,24,30.4,24H328V360Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.873,367.823a143.981,143.981,0,0,1,86.832-148.359C254.827,191.354,221.225,176,184,176c-36.9,0-70.938,15.487-95.833,43.609-24.992,28.23-39.15,67.706-40.114,111.581C64.2,339.412,124.617,368,184,368,186.924,368,189.889,367.939,192.873,367.823Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M328,296h-1.6c-16.762,0-30.4,10.767-30.4,24s13.638,24,30.4,24H328Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M376,384c0-13.233-13.638-24-30.4-24H344v48h1.6C362.362,408,376,397.233,376,384Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenue);
export default __webpack_public_path__ + "static/media/revenue.0bf595b70dd4e6eece672e1e414320ce.svg";
export { ForwardRef as ReactComponent };